import { safeParseJson } from '../utils/safeParseJson';

export const LAST_GRADE_SESSION_STORAGE_KEY = 'dg_last_grade_session_v1';

export type LastGradeSession = {
  courseId: string;
  assignmentId: string;
  courseName: string;
  assignmentTitle: string;
  savedAt: number;
};

function isValidSession(raw: unknown): raw is LastGradeSession {
  if (!raw || typeof raw !== 'object') return false;
  const o = raw as Record<string, unknown>;
  return (
    typeof o.courseId === 'string' &&
    o.courseId.length > 0 &&
    typeof o.assignmentId === 'string' &&
    o.assignmentId.length > 0 &&
    typeof o.courseName === 'string' &&
    typeof o.assignmentTitle === 'string' &&
    typeof o.savedAt === 'number'
  );
}

export function loadLastGradeSession(): LastGradeSession | null {
  const parsed = safeParseJson<unknown>(localStorage.getItem(LAST_GRADE_SESSION_STORAGE_KEY), null);
  return isValidSession(parsed) ? parsed : null;
}

export function saveLastGradeSession(input: {
  courseId: string;
  assignmentId: string;
  courseName: string;
  assignmentTitle: string;
}): void {
  try {
    const payload: LastGradeSession = {
      ...input,
      savedAt: Date.now(),
    };
    localStorage.setItem(LAST_GRADE_SESSION_STORAGE_KEY, JSON.stringify(payload));
  } catch {
    // ignore quota / private mode
  }
}

export function clearLastGradeSession(): void {
  try {
    localStorage.removeItem(LAST_GRADE_SESSION_STORAGE_KEY);
  } catch {
    // ignore
  }
}
